import { useMemo, useState } from "react";
import { createPortal } from "react-dom";
import { HeaderActionsContext, useHeaderActionsContext } from "./header-actions-context";

export function HeaderActionsProvider({ children }: { children: React.ReactNode }) {
  const [slot, setSlot] = useState<HTMLElement | null>(null);
  const value = useMemo(() => ({ slot, setSlot }), [slot]);
  return <HeaderActionsContext.Provider value={value}>{children}</HeaderActionsContext.Provider>;
}

/**
 * Where page actions land in the header. The callback ref sets state, not an effect, so mounting
 * the slot cannot loop.
 */
export function HeaderActionsSlot() {
  const { setSlot } = useHeaderActionsContext();
  return (
    <div
      data-testid="admin-header-actions"
      ref={setSlot}
      className="flex items-center gap-2 empty:hidden"
    />
  );
}

/** Portals its children into the header slot; renders nothing without one. */
export function HeaderActions({ children }: { children: React.ReactNode }) {
  const { slot } = useHeaderActionsContext();
  return slot ? createPortal(children, slot) : null;
}
